import { atom } from "recoil";

export enum NotificationKey {
  ReportDraft,
  ReportPending,
  ReportResolved,
  StipendsPending,
  StipendsResolved,
}

export const notificationState = atom<Map<NotificationKey, number>>({
  key: "notificationState",
  default: new Map(),
});
